import React from 'react';
import FilterBase from './FilterBase';
import styles from 'styles/partials/_filterlong.css';
import getValue from 'components/connectedForm/utils/getValue';
import Dropdown from 'components/connectedForm/Dropdown';
import fieldMetaData from 'graphql/schema/fieldMetaData';
import { BlurTextField } from '../connectedForm/inputComponents';
import { BlurTextFieldType } from '../connectedForm/BlurTextField/BlurTextField';
import { FilterNumberType } from '../../graphql/schema/p4types';

export default class FilterLong extends FilterBase {
  constructor(props) {
    super(props);

    this.getDescription = this.getDescription.bind(this);
    this.getQueryFilters = this.getQueryFilters.bind(this);
    this.renderPopout = this.renderPopout.bind(this);
  }

  getInitialValues(props) {
    const initialValues = Object.assign({}, props);
    if (!props.filterType) {
      initialValues.filterType = 'RANGE';
    }

    delete initialValues.label;
    delete initialValues.type;
    delete initialValues.fieldName;
    delete initialValues.onFilterUpdated;
    delete initialValues.position;
    delete initialValues.dispatch;
    delete initialValues.list;
    delete initialValues.initiallyOpen;

    return initialValues;
  }

  getDescription() {
    const { from, to, filterType } = this.committedValues;
    if (filterType === 'RANGE' && from && to) {
      return `${from} - ${to}`;
    }
    let description = 'All';
    switch (filterType) {
      case 'EQUALS':
        description = `= ${from}`;
        break;
      case 'NOT_EQUALS':
        description = `<> ${from}`;
        break;
      case 'LESS_THAN':
        description = `< ${from}`;
        break;
      case 'LESS_THAN_EQUAL':
        description = `<= ${from}`;
        break;
      case 'GREATER_THAN':
        description = `> ${from}`;
        break;
      case 'GREATER_THAN_EQUAL':
        description = `>= ${from}`;
        break;
      case 'IN':
        description = `IN (${from}'`;
        break;
    }
    return description;
  }

  getQueryFilters() {
    const queryFilters = [];
    if (this.state.filterValues.from) {
      queryFilters.push({
        fieldName: this.props.fieldName,
        operation: '>=',
        value: this.state.filterValues.from,
      });
    }
    if (this.state.filterValues.to) {
      queryFilters.push({
        fieldName: this.props.fieldName,
        operation: '<=',
        value: this.state.filterValues.to,
        includeNull: !this.state.filterValues.from,
      });
    }

    return queryFilters;
  }

  handleChange(id, value) {
    const filterValues = Object.assign({}, this.state.filterValues, {
      [id]: value,
    });
    if (
      id === 'filterType' &&
      value !== FilterNumberType.In &&
      this.state.filterValues?.filterType === FilterNumberType.In
    ) {
      //If we switch from 'in' to another type, wipe out the 'from' field because its' likely to be invalid.
      filterValues.from = '';
    }

    this.setState({ filterValues: filterValues });
  }

  renderPopout() {
    const messages = this.checkValueRange();
    const {
      filterValues: { filterType, from, to },
    } = this.state;

    return (
      <div className={styles.container}>
        <Dropdown
          autoFocus={true}
          id="filterType"
          setInputRef={this.setInputRef}
          label="Type"
          onChange={(value) => this.handleChange('filterType', getValue(value))}
          enum={true}
          options={fieldMetaData.FilterNumberType.enumValues}
          value={filterType}
          menuContainerStyle={{ maxWidth: '210px' }}
        />
        <BlurTextField
          id="from"
          label={filterType && filterType !== 'RANGE' ? 'Number' : 'From'}
          value={from}
          onChange={(value) => this.handleChange('from', value)}
          enableOnChange={true}
          type={filterType === FilterNumberType.In ? BlurTextFieldType.TextArea : undefined}
          clearable={filterType === FilterNumberType.In ? true : undefined}
          hint={
            filterType === FilterNumberType.In ? (
              <div>
                Enter values seperated by a comma, space or new-lines. Any (exact) matches will be included in the
                results.
                <br />
                <br />
                {'E.g. "2200, 2205, 2358"'}
              </div>
            ) : undefined
          }
        />
        {filterType && filterType === 'RANGE' ? (
          <BlurTextField
            id="to"
            label="To"
            value={to}
            onChange={(value) => this.handleChange('to', value)}
            message={messages}
            enableOnChange={true}
          />
        ) : null}
      </div>
    );
  }
}
